import Vue from 'vue'

Vue.prototype.$bus = new Vue() // 就是这么简单
